import axios from 'axios'
import UserProfile from '../models/userProfile'
import { RequestPaymentConfirmationType, RequestPaymentType } from '../types'

const apiURL = process.env.REACT_APP_API_URL

export const getProfile = async (): Promise<UserProfile> => {
  const getUserURL = `${apiURL}/auth/user`

  const data = await axios.get(getUserURL)
  return data.data
}

export const getCard = async () => {
  const getCardURL = `${apiURL}/me/card`

  const data = await axios.get(getCardURL)
  return data.data
}

export const payment = async (data: RequestPaymentType): Promise<any> => {
  const paymentURL = `${apiURL}/payment/card`
  const res = await axios.post(paymentURL, data)

  return res
}

export const getResPaymentConfirmation = async (
  data: RequestPaymentConfirmationType
) => {
  const paymentURL = `${apiURL}/payment/card/confirm`
  const res = await axios.post(paymentURL, data)

  return res.data
}

export const getShopIdApi = async () => {
  const getShopIdURL = `${apiURL}/gmo/config`
  const res = await axios.get(getShopIdURL)

  return res.data
}
